"use client";

// ──────────────────────────────────────────────────────────────────────────
//  Admin gating — controls whether admin-only UI (the loot-cache upload
//  page, future tier-rotation buttons, etc.) is visible.
//
//  Single source of truth: the backend's `is_admin` flag on /api/auth/me,
//  which is true iff the signed-in user's BattleTag matches the server's
//  ADMIN_BATTLETAG env var. Anything else (localStorage flags, query
//  params, hostname checks) was a pre-auth-flow workaround and is gone.
//
//  This is a UI hint, not a security boundary — the actual privilege
//  check is on the backend (/api/loot/cache requires the same flag).
// ──────────────────────────────────────────────────────────────────────────

import { useAuth } from "./auth";

/** Reactive: returns true iff the current user is the configured admin. */
export function useAdminVisible(): boolean {
  const auth = useAuth();
  return auth.state === "signed-in" && auth.user.is_admin;
}
